module.exports = __webpack_public_path__ + "img/icon19.9615825f.png";